import {UserMeDto} from 'api/dtos/UserMeDto';
import {axiosInstance} from '../axiosInstance';
import {userPath} from '../paths';
export const getCurrentUser = async () => await axiosInstance.get<UserMeDto>(userPath.me()).then((res) => res.data);
